import { FC, ReactNode } from "react";
import { Content } from "@jobber/components/Content";
import { Heading } from "@jobber/components/Heading";
import { Text } from "@jobber/components/Text";
import { Button } from "@jobber/components/Button";
import { Spinner } from "@jobber/components/Spinner";
import { AuthFlowButton } from "../../types";

type SettingsFrameProps = {
    readonly children: ReactNode | ReactNode[];
    title: string,
    button: AuthFlowButton,
    loading?: boolean,
    loadingMessage?: string,
};

const SettingsFrame: FC<SettingsFrameProps> = ({
    children,
    title,
    button,
    loading = false,
    loadingMessage = "Loading",
}) => {
    return (
        <div
            style={{
                width: "100%",
                padding: "40px",
                display: "flex",
                gap: "40px",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            {loading ? (
                <>
                    <Content spacing={"base"}>
                        <Heading level={1}>{title}</Heading>
                    </Content>
                    <div
                        style={{
                            flex: 1,
                            minHeight: "317px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "16px",
                            textAlign: "center",
                        }}
                    >
                        <Spinner />
                        <Text size={"large"}>{loadingMessage}</Text>
                    </div>
                </>
            ) : (
                <>
                    <Content spacing={"larger"}>
                        <Content spacing={"base"}>
                            <Heading level={1}>{title}</Heading>
                        </Content>
                        <div
                            style={{
                                maxWidth: "715px",
                                minHeight: "317px",
                            }}
                        >
                            {children}
                        </div>

                        <div
                            id={"errors"}
                            style={{
                                display: "flex",
                                gap: "10px",
                                flexDirection: "column",
                                justifyContent: "space-between",
                            }}
                        ></div>
                    </Content>

                    <Content spacing={"base"}>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                url={button.link || undefined}
                                label={button.text}
                                type={button.type}
                                disabled={button.disabled}
                                loading={button.loading}
                                onClick={button.onClick}
                            />
                        </div>
                    </Content>
                </>
            )}
        </div>
    );
};

export default SettingsFrame;
